// @flow

import axios from 'axios'

import { logger } from './logger'
import { getUploadFileUrl, deleteFile } from './api/chatchampApi'

export async function deleteFileFromS3 (customerId: string, subscriberId: string, fileS3Key: string): Promise<any> {
  try {
    await deleteFile(customerId, subscriberId, fileS3Key)
    return true
  } catch (err) {
    logger.info(err)
  }
}

export async function uploadFileToS3 (customerId: string, subscriberId: string, file: File): Promise<any> {
  try {
    const { signedUrl, key } = await getUploadFileUrl(customerId, subscriberId, file.name, file.type, 'widget')
    const result = await axios.put(signedUrl, file, { headers: { 'Content-Type': file.type } })
    const bucketUrl = decodeURIComponent(result.request.responseURL).split(key)[0]
    const fullPath = bucketUrl + key
    return { fullPath, key }
  } catch (e) {
    logger.info(e)
  }
}
